import React, { FC } from 'react';
import { Paper, Box, Grid, Typography, Tooltip } from '@mui/material';
import { File, OrderEvent } from 'models/order-event';
import EventRecordTitle from 'components/shared/order-events-timeline/order-events/event-record-title.component';
import EventImageItem from 'components/shared/order-events-timeline/order-events/event-files/event-image-item.component';
import EventFileItem from 'components/shared/order-events-timeline/order-events/event-files/event-file-item.component';
import { eventAuthor } from 'components/shared/order-events-timeline/event-organization';
import { useTranslation } from 'react-i18next';

type EventFilesProps = {
    item: OrderEvent;
    displayOrderLabel?: boolean;
    onImageClick: (imageUrl: string) => void;
};
const EventFiles: FC<EventFilesProps> = ({ item, displayOrderLabel, onImageClick }: EventFilesProps) => {
    const { t: translate } = useTranslation(['order-event']);

    const eventTitle = () => `${translate('FILES_UPLOADED_BY')} ${eventAuthor(item, translate('API_INTEGRATION'))}`;

    const isImage = (file: File): boolean => {
        return file.mimetype.includes('image');
    };

    return (
        <Paper variant="outlined">
            <Box p={2}>
                <EventRecordTitle
                    title={eventTitle()}
                    item={item}
                    color={item.color}
                    displayOrderLabel={displayOrderLabel}
                />
                <Box mt={1}>
                    {item.files ? (
                        <Grid container spacing={1}>
                            {item.files.map(
                                (file: File) =>
                                    file && (
                                        <Grid key={file?.url} item sm={2} sx={{ cursor: 'pointer' }}>
                                            {isImage(file) ? (
                                                <Box
                                                    onClick={() => {
                                                        onImageClick(file.url);
                                                    }}
                                                >
                                                    <EventImageItem fileId={file._id} url={file.url} />
                                                </Box>
                                            ) : (
                                                <EventFileItem url={file.url} />
                                            )}
                                            <Box
                                                sx={{
                                                    textAlign: 'center',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                <Tooltip title={file.filename}>
                                                    <Typography variant="caption">{file.filename}</Typography>
                                                </Tooltip>
                                            </Box>
                                        </Grid>
                                    ),
                            )}
                        </Grid>
                    ) : undefined}
                </Box>
            </Box>
        </Paper>
    );
};

export default EventFiles;
